import { FileText, Search, Filter, Plus } from 'lucide-react';

const FG = '#F5F1FA';
const MUTED = '#A99FB8';
const SURFACE2 = '#140C20';
const SURFACE = '#1B1029';
const VIOLET = '#6D28D9';
const VIOLET_LIGHT = '#A855F7';
const CHAMPAGNE = '#E8B96A';
const BORDER = 'rgba(255,255,255,0.08)';

const MODELOS = [
  { titulo: 'Procuração', updated: 'Atualizado há 1 sem.', hasVar: false },
  { titulo: 'Contrato de honorários', updated: 'Atualizado há 1 sem.', hasVar: true },
  { titulo: 'Petição inicial', updated: 'Atualizado há 1 sem.', hasVar: false },
  { titulo: 'Acordo extrajudicial', updated: 'Atualizado há 2 sem.', hasVar: false },
  { titulo: 'Declaração', updated: 'Atualizado há 3 sem.', hasVar: false },
  { titulo: 'Recibo', updated: 'Atualizado há 4 sem.', hasVar: false },
];

export function DocumentosMockup() {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        border: `1px solid ${BORDER}`,
        background: SURFACE2,
        boxShadow:
          '0 0 0 1px rgba(109,40,217,0.15), 0 32px 80px rgba(0,0,0,0.55), 0 8px 24px rgba(109,40,217,0.12)',
        fontFamily: "'Hanken Grotesk', sans-serif",
      }}
    >
      {/* Titlebar */}
      <div
        style={{
          background: 'rgba(20,12,32,0.98)',
          borderBottom: `1px solid rgba(255,255,255,0.07)`,
          padding: '12px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
          {['#FF5F56', '#FFBD2E', '#27C93F'].map((c) => (
            <span
              key={c}
              style={{
                width: 11,
                height: 11,
                borderRadius: '50%',
                background: c,
                opacity: 0.75,
                display: 'inline-block',
              }}
            />
          ))}
        </div>
        <FileText size={13} color={CHAMPAGNE} strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: FG }}>Documentos</span>
      </div>

      {/* Abas */}
      <div
        style={{
          background: 'rgba(20,12,32,0.6)',
          borderBottom: `1px solid ${BORDER}`,
          padding: '0 16px',
          display: 'flex',
          alignItems: 'flex-end',
          gap: 0,
        }}
      >
        {['Modelos', 'Documentos gerados'].map((aba, i) => (
          <span
            key={aba}
            style={{
              fontSize: 11,
              fontWeight: i === 0 ? 700 : 400,
              color: i === 0 ? VIOLET_LIGHT : MUTED,
              padding: '10px 14px 8px',
              borderBottom: i === 0 ? `2px solid ${VIOLET_LIGHT}` : '2px solid transparent',
              cursor: 'default',
              lineHeight: 1,
            }}
          >
            {aba}
          </span>
        ))}
      </div>

      {/* Toolbar */}
      <div
        className="docs-toolbar"
        style={{
          padding: '10px 14px',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          borderBottom: `1px solid ${BORDER}`,
        }}
      >
        {/* Campo busca */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            background: SURFACE,
            border: `1px solid ${BORDER}`,
            borderRadius: 7,
            padding: '5px 10px',
          }}
        >
          <Search size={11} color={MUTED} strokeWidth={2} />
          <span style={{ fontSize: 11, color: 'rgba(169,159,184,0.4)' }}>Buscar modelo...</span>
        </div>

        {/* Filtrar */}
        <button
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 10,
            fontWeight: 600,
            color: MUTED,
            background: SURFACE,
            border: `1px solid ${BORDER}`,
            borderRadius: 7,
            padding: '5px 10px',
            cursor: 'default',
            fontFamily: 'inherit',
          }}
        >
          <Filter size={10} strokeWidth={2} />
          Filtrar
        </button>

        {/* Criar em branco */}
        <button
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 10,
            fontWeight: 700,
            color: FG,
            background: `linear-gradient(135deg, ${VIOLET} 0%, ${VIOLET_LIGHT} 100%)`,
            border: 'none',
            borderRadius: 7,
            padding: '5px 11px',
            cursor: 'default',
            fontFamily: 'inherit',
          }}
        >
          <Plus size={11} strokeWidth={2.5} />
          Criar em branco
        </button>
      </div>

      <style>{`
        @media (max-width: 600px) {
          .docs-card-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .docs-toolbar { flex-wrap: wrap; }
        }
      `}</style>
      {/* Grid de cards */}
      <div
        className="docs-card-grid"
        style={{
          padding: '14px 14px 16px',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 10,
        }}
      >
        {MODELOS.map((modelo, i) => (
          <div
            key={i}
            style={{
              background: SURFACE,
              border: `1px solid ${BORDER}`,
              borderRadius: 10,
              overflow: 'hidden',
              cursor: 'default',
            }}
          >
            {/* Area do icone */}
            <div
              style={{
                background: 'rgba(27,16,41,0.8)',
                borderBottom: `1px solid ${BORDER}`,
                padding: '16px 0 12px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: 'rgba(109,40,217,0.15)',
                  border: `1px solid rgba(168,85,247,0.2)`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FileText size={16} color={VIOLET_LIGHT} strokeWidth={1.5} />
              </div>

              {/* Chip de variavel no card 1 (contrato) */}
              {modelo.hasVar && (
                <div
                  style={{
                    fontSize: 8,
                    fontWeight: 700,
                    color: CHAMPAGNE,
                    background: 'rgba(232,185,106,0.12)',
                    border: `1px solid rgba(232,185,106,0.3)`,
                    borderRadius: 4,
                    padding: '2px 7px',
                    fontFamily: "'Hanken Grotesk', sans-serif",
                  }}
                >
                  [[Nome do cliente]]
                </div>
              )}
            </div>

            {/* Info */}
            <div style={{ padding: '9px 10px 10px' }}>
              <p
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: FG,
                  margin: '0 0 3px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                {modelo.titulo}
              </p>
              <p style={{ fontSize: 9, color: MUTED, margin: 0 }}>{modelo.updated}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
